import { ReactNode } from "react";
import { IntegrationName } from "./Integration.model";
import ZendeskLogoSVG from "../../components/icons/connections/ZendeskLogoSVG";
import Document360LogoSVG from "../../components/icons/connections/Document360LogoSVG";
import GitbookLogoSVG from "../../components/icons/connections/GitbookLogoSVG";
import FrontLogoSVG from "../../components/icons/connections/FrontLogoSVG";
import FreshdeskLogoSVG from "../../components/icons/connections/FreshdeskLogoSVG";
import SalesforceLogoSVG from "../../components/icons/connections/SalesforceLogoSVG";
import HubSpotLogoSVG from "../../components/icons/connections/HubSpotLogoSVG";
import IntercomLogoSVG from "../../components/icons/connections/IntercomLogoSVG";
import SlackLogoSVG from "@/components/icons/connections/SlackLogoSVG";
import ConfluenceLogoSVG from "@/components/icons/connections/ConfluenceLogoSVG";
import NotionLogoSVG from "@/components/icons/connections/NotionLogoSVG";
import JiraLogoSVG from "@/components/icons/connections/JiraLogoSVG";
import KustomerLogoSVG from "@/components/icons/connections/KustomerLogoSVG";
import GoogleDriveLogoSVG from "@/components/icons/connections/GoogleDriveLogoSVG";
import MondayLogoSVG from "@/components/icons/connections/MondayLogoSVG";
import PlainLogoSVG from "@/components/icons/connections/PlainLogoSVG";
import HelpscoutLogoSVG from "@/components/icons/connections/HelpscoutLogoSVG";
import GorgiasLogoSVG from "@/components/icons/connections/GorgiasLogoSVG";
import ApiBasedLogoSVG from "@/components/icons/connections/ApiBasedLogoSVG";
import PriorityLogoSVG from "@/components/icons/connections/PriorityLogoSVG";
import SmoochLogoSVG from "@/components/icons/connections/SmoochLogoSVG";
import ElevioLogoSVG from "@/components/icons/connections/ElevioLogoSVG";

type GalleryItem = {
  title: string;
  svg: ReactNode;
};

export const integrationNameToGalleryItem: Record<
  IntegrationName,
  GalleryItem
> = {
  zendesk: {
    title: "Zendesk",
    svg: <ZendeskLogoSVG />,
  },
  front: {
    title: "Front",
    svg: <FrontLogoSVG />,
  },
  freshdesk: {
    title: "Freshdesk",
    svg: <FreshdeskLogoSVG />,
  },
  hubspot: {
    title: "HubSpot",
    svg: <HubSpotLogoSVG />,
  },
  salesforce: {
    title: "Salesforce",
    svg: <SalesforceLogoSVG />,
  },
  intercom: {
    title: "Intercom",
    svg: <IntercomLogoSVG />,
  },
  kustomer: {
    title: "Kustomer",
    svg: <KustomerLogoSVG />,
  },

  document360: {
    title: "Doc360",
    svg: <Document360LogoSVG />,
  },
  notion: {
    title: "Notion",
    svg: <NotionLogoSVG />,
  },
  confluence: {
    title: "Confluence",
    svg: <ConfluenceLogoSVG />,
  },
  gitbook: {
    title: "Gitbook",
    svg: <GitbookLogoSVG />,
  },
  slack: {
    title: "Slack",
    svg: <SlackLogoSVG />,
  },
  jira: {
    title: "Jira",
    svg: <JiraLogoSVG />,
  },
  google_drive: {
    title: "Google Drive",
    svg: <GoogleDriveLogoSVG />,
  },
  monday: {
    title: "Monday.com",
    svg: <MondayLogoSVG />,
  },
  helpscout: {
    title: "Help Scout",
    svg: <HelpscoutLogoSVG />,
  },
  plain: {
    title: "Plain",
    svg: <PlainLogoSVG />,
  },
  gorgias: {
    title: "Gorgias",
    svg: <GorgiasLogoSVG />,
  },
  apibased: {
    title: "API Based",
    svg: <ApiBasedLogoSVG />,
  },
  priority: {
    title: "Priority",
    svg: <PriorityLogoSVG />,
  },
  smooch: {
    title: "Smooch",
    svg: <SmoochLogoSVG />,
  },
  salesforce_livechat: {
    title: "Salesforce Live Chat",
    svg: <SalesforceLogoSVG />,
  },
  elevio: {
    title: "Elevio",
    svg: <ElevioLogoSVG />,
  },
};
